import { SetLocalePayload } from '@/commons/types'
import { commonTranslations } from '@/commons/translations'
import { VuexModule, Module, Action } from 'vuex-class-modules'
import {
    FALLBACK_LOCALE,
    SETTINGS_LOCALE_KEY
} from '@/commons/constants/locale'

@Module({ generateMutationSetters: true })
export default class Settings extends VuexModule {
    private locale = localStorage.getItem(SETTINGS_LOCALE_KEY)

    @Action
    setLocale (payload: SetLocalePayload): void {
        localStorage.setItem(SETTINGS_LOCALE_KEY, payload.locale)
        this.locale = payload.localeContext.locale = payload.locale
    }

    get verifiedLocale (): string {
        const allLocales = Object.keys(commonTranslations)
        const hasLocaleKey = Object.prototype.hasOwnProperty.call(localStorage, SETTINGS_LOCALE_KEY)

        if (!allLocales.some(loc => loc === this.locale) && hasLocaleKey) {
            localStorage.removeItem(SETTINGS_LOCALE_KEY)
            return FALLBACK_LOCALE
        }
        return this.locale || FALLBACK_LOCALE
    }
}
